import axios from 'axios';

export default {
    fetchUsersByRole(role = 'rep') {
        return axios.get('/api/users', { params: { role } });
    },
};
